@import '../../styles/mixins/_btalk-mixins.scss';
@import '../../styles/variables/_btalk-variables.scss';
@import '../../styles/classes.scss';
@import '../../styles/header-nav.scss';
@import '../../styles/buttons.scss';

:host {
  display: block;
}

.btalk-nav-wrap.mobile {

  .btalk-nav {
    margin: 0 auto;
    width: $site-width;
    max-width: $site-max-width;
  }
}
